import React, {useEffect, useState} from "react";
import {fetchPost} from "../utils/FetchUtil.ts";
import {Modal, ModalBody, ModalHeader, ModalTitle} from "react-bootstrap";
import {url} from "../utils/UrlsUtil.ts";
import EventMsgSamplesSwiper from "../components/swiper/EventMsgSamplesSwiper.tsx";
import "../../style/modal/event_msg_samples_modal.scss";

interface EventMsgSamplesModalProps {
    genre: 'ems' | 'txo';
    show: boolean;
    onClosed: () => void;
    onSelected: ( msg:string ) => void;
}

const EventMsgSamplesModal:React.FC<EventMsgSamplesModalProps> = ({
    genre = 'ems',
    show = false,
    onClosed = () => {},
    onSelected = () => {}
}) => {
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string>("");
    const [sampleList, setSampleList] = useState<SampleMessageDto[]>([]);
    useEffect(() => {
        const getSampleList = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/event/message/samples",
                    data: {genre: genre, event_category_code: selectedCategoryCode},
                });
                if(data != null){
                    // @ts-ignore
                    setSampleList(data);
                }
            }catch (e) {
                console.log(e);
            }
        }
        getSampleList().finally(()=>{});
    }, [selectedCategoryCode]);
    const onSelectedCategory = (code: string) => {
        setSelectedCategoryCode(code);
    }
    return (
        <Modal className="event-msg-template-modal" show={show} onHide={onClosed} centered>
            <ModalHeader closeButton>
                <ModalTitle><img src={url("/images/logo/geeva_logo.png")} alt="geeva"/></ModalTitle>
            </ModalHeader>
            <ModalBody>
                <h2>メッセージをイベントからお選びください</h2>
                <EventMsgSamplesSwiper genre={genre} showSample={false} onSelectedCategory={onSelectedCategory}></EventMsgSamplesSwiper>
                {sampleList && sampleList.length > 0 && sampleList.map((msg: SampleMessageDto, index: number) =>
                    <dl className={`msg-tmp-item`} key={`dl_msg_tmp_${index}`}
                        onClick={()=>{onSelected(msg.sample_message)}}
                    >
                        <dt>{msg.title}</dt>
                        <dd dangerouslySetInnerHTML={{ __html: msg.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></dd>
                    </dl>)}
            </ModalBody>
        </Modal>
    );
};
export default EventMsgSamplesModal;